import React from 'react';

export default class SemiFooter extends React.Component{
    render(){
        return(
            <div>
                <div className="container-fluid p-0 semiFooterCor">
                    <div className="semiFooter"></div>
                    <div className="row FooterIndex">
                        {/* <div className="col-md-3 text-center">
                        <h1 style={{marginTop:45, fontFamily: 'Pacifico'}}>Loja 01</h1>
                        <p style={{marginTop:15, fontFamily: 'Muli'}}>
                            AV.TOMAZ LANDIN, 3500 <br/>
                            LOJA 2 E 3 - IGAPÓ - NATAL/RN <br/>
                            (84) 99959.0018 <br/>
                            (84) 3301.1786 <br/>
                        </p>
                        </div> */}
                        <div className="col-md-6 text-center">
                        <h1 style={{marginTop:45, fontFamily: 'Pacifico'}}>MATRIZ</h1>
                        <p style={{marginTop:15, fontFamily: 'Muli'}}>
                            ROD BR 406, KM 220 <br/>
                            LOTEAMENTO PLAZA GARDEM <br/>
                            SÃO GONÇALO DO <br/>
                            AMARENTE/RN <br/>
                            (84) 99920-0037 PRINCIPAL<br/>
                            (84) 99959-0018 WHATSAPP<br/>
                            (84) 3301.1786<br/>
                            (84) 3664.2046<br/>
                        </p>
                        </div>
                        <div className="col-md-6 text-center">
                        <h1 style={{marginTop:45, fontFamily: 'Pacifico'}}>LOJA CEASA</h1>
                        <p style={{marginTop:15, fontFamily: 'Muli'}}>
                            AV. CAPITÃO MOR GOUVEIA, <br/>
                            3005 - BOX 12 - LAGOA NOVA <br/>
                            NATAL/RN <br/>
                            (84) 99920-0037 WHATSAPP<br/>
                        </p>
                        </div>

                        {/* <div className="col-md-3 text-center">
                        <h1 style={{marginTop:45, fontFamily: 'Pacifico'}}>Loja 04</h1>
                        <p style={{marginTop:15, marginBottom:60, fontFamily: 'Muli'}}>
                            AV. PILOTO PEREIRA TIM, 180 <br/>
                            CENTRO BR 101 - PARNAMIRIM/RN <br/>
                            CEP 59140-001 <br/>
                            (84) 3302.4368 <br/>
                            (84) 99920.0037 WHATSAPP
                        </p>
                        </div> */}
                    </div>

                </div>
            </div>
        );
    }
}
